/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgLock24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#6F757C'
        fillRule='evenodd'
        d='M12.1.25h-.096A5.701 5.701 0 006.25 5.892v4.358h-4v13.5h19.5v-13.5h-4V6.004A5.7 5.7 0 0012.108.25H12.1zm4.15 10V5.993a4.201 4.201 0 00-4.154-4.243H11.992A4.2 4.2 0 007.75 5.904v4.346h8.5zm-12.5 1.5v10.5h16.5v-10.5H3.75zm8.25 4a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM9.25 17a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0z'
      />
    </svg>
  );
}

export default SvgLock24;
